import { type FullUserBookingWithAccoDetails } from '@vakantiesnl/services/src/user';
import { getDateWithoutTime } from '@vakantiesnl/services/src/util/dateUtils';
import dayjs from 'dayjs';

export function getIsPastBooking(userBookingData: FullUserBookingWithAccoDetails): boolean {
	const now = dayjs().startOf('day');
	const formattedReturnDate = getDateWithoutTime(userBookingData.returnDate);

	return now.isAfter(formattedReturnDate);
}
